<template>
	<v-dialog v-model="dialogUserCursos" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="editedItem.curso_id"
									:items="cursos"
									item-text="nome"
									item-value="id"
									label="Selecione um curso"
									:rules="[rules.required]"
								></v-select>
							</v-col>
              <v-col cols="12">
                <v-switch
                  v-model="editedItem.mostrar"
                  color="indigo"
                  label="Mostrar ao aluno"
                ></v-switch>
              </v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'


export default {
	inheritAttrs: false,
	props: {
		usuario: undefined,
		userCursos: {
			default: null,
		},
		typeForm: {
			default: 0,
		},
		cursos: null,
	},

	data() {
		return {
			server: 'user_curso',
			editedItem: {
				id: 0,
				curso_id: undefined,
        mostrar: 1,
        liberar_certificado: 0
			},
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogUserCursos']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
			this.editedItem = Object.assign({}, this.userCursos)
			this.editedItem.mostrar=(this.editedItem.mostrar==1)? true:false
			this.editedItem.liberar_certificado=(this.editedItem.liberar_certificado==1)? true:false
		}
	},

	methods: {
		close() {
			this.$store.dispatch('dialogUserCursos', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { typeForm: 0, hideForm: 'userCursos' })
			}, 300)
		},

		save() {
			if (this.$refs.form.validate()) {
				if (this.typeForm === 0) {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('usuario_id', this.usuario.id)
					formData.append('curso_id', this.editedItem.curso_id)
					formData.append('mostrar', this.editedItem.mostrar)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('id', this.editedItem.id)
					formData.append('usuario_id', this.usuario.id)
					formData.append('curso_id', this.editedItem.curso_id)
          formData.append('mostrar', this.editedItem.mostrar)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.close()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				}
			}
		},
	},
}
</script>
